<template lang="pug">
  v-container
    .middle     
      v-card(
        max-width="100%"
        elevation="10"        
      ).mx-auto.rounded-lg
        v-card-title {{ $t('monitoravailability') }}
        v-card-text
          v-divider
          v-container
            iframe(
              src="https://nufi.checklyhq.com/"    
              :height="height"
              width="100%"
              style="border:none;")
  
</template>
<script>
export default {
  props: {
    height: {
      type: String,
      default: "600px"
    }
  }
}
</script>